import { render, staticRenderFns } from "./RGB.vue?vue&type=template&id=1f6db491&"
import script from "./RGB.vue?vue&type=script&lang=js&"
export * from "./RGB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports